const DEFAULT_AUTH_REDIRECT = "/"
const REDIRECT_PARSE_BASE = "https://aix-command-center.local"

function parseSafeAuthRedirect(redirect: unknown): string | null {
  if (typeof redirect !== "string") {
    return null
  }

  const value = redirect.trim()
  if (!value.startsWith("/") || value.startsWith("//")) {
    return null
  }

  try {
    const url = new URL(value, REDIRECT_PARSE_BASE)
    const pathname = url.pathname.endsWith("/") && url.pathname !== "/" ? url.pathname.slice(0, -1) : url.pathname

    if (pathname === "/auth" || pathname.startsWith("/auth/") || pathname === "/signout") {
      return null
    }

    return `${url.pathname}${url.search}${url.hash}`
  } catch {
    return null
  }
}

export function getSafeAuthRedirect(redirect: unknown): string {
  return parseSafeAuthRedirect(redirect) ?? DEFAULT_AUTH_REDIRECT
}

export function getSafeAuthRedirectFromCandidates(...redirects: unknown[]): string {
  for (const redirect of redirects) {
    const safeRedirect = parseSafeAuthRedirect(redirect)
    if (safeRedirect) {
      return safeRedirect
    }
  }

  return DEFAULT_AUTH_REDIRECT
}
